import sample_1 from './proban.jpg';

export const proban = {
    sample_1,
};
